export default __webpack_public_path__ + "static/media/5.6d711265.jpg";